export default [
  {
    version: '1.0.1',
    changes: [
      'New characters: Zhongli and Xinyan',
      'Fixed Safari UI not displaying properly.(thanks to u/Pizza0309 for pointing this out )',
      "Fixed an issue where Martial Artist's DMG% increase would increase Total ATK instead of damage. (thanks to u/DucksforDinner for pointing this out)",
      'Fixed an issue where DMG% from set bonuses would not apply correctly.',
      'Added character specific stats to their information window.'
    ]
  }
]
